// @ts-ignore
import FieldsFactory1 from "../../fields/fields-factory"

// const debug = "Formula"
const debug = false

// this patches formula and replaces OLD names with new Names
// in future we need something better
function patchToFixOldVariableNames(fieldName:string) {
    switch (fieldName) {
        case 'cost, internal':
            return 'labor cost'
        case 'cost, service':
            return 'service cost'
        case 'progress (auto)':
            return 'Progress Tasks'.toLowerCase()
        default:
            return fieldName
    }
}

export function formulaField3Factory(variable: string) {
    switch (variable) {
        case '{PROJECT-ESTIMATE-TASKS}':
            return gd.fields.project.estimateTasks
        case '{PROJECT-ESTIMATED-LABOR-COST}':
            return gd.fields.project.estimatedCostInternal
        case '{PROJECT-ESTIMATED-SERVICE-COST}':
            return gd.fields.project.estimatedCostExternal
        default:
            return null
    }
}

export function formulaField1Factory(fieldName:string, systemFieldTypeV1:string, customFields : any,) {

    debug && console.log(debug, 'formulaField1Factory', fieldName, systemFieldTypeV1, customFields)

    switch (fieldName) {

        default:
            if (systemFieldTypeV1) {
                return FieldsFactory1.get(systemFieldTypeV1);
            } else {
                //if not found search for custom field
                let filtered = customFields.filterByName(fieldName);
                if (filtered.length > 0) {
                    let fields = _.map(filtered, customField => FieldsFactory1.get(gd.const.fields.type.CUSTOM_FIELD, customField.id))

                    debug && console.log(debug, 'formulaField1Factory filtered fields', fields)

                    return _.find(fields, field=>field?.isFormulaCompatible())
                }
            }
    }

    console.log("#djdhhd232 HOW COME ")
}

const Formula = {

    _getFieldsInFormula(inputText:string) {
        let res : any = [];

        if (!!inputText && typeof inputText === 'string') {

            //find all fields matches
            const regexp = new RegExp(/\{(.+?)\}/, 'gmis');
            const matches = [...inputText.matchAll(regexp)];

            // prepare custom fields for search
            const customFields              = gd.session.customFields.filterByCompany(gd.companyId);
            const systemFieldsNamesId : any = {};

            _.mapKeys(gd.const.fields.labels, (value, key)=>{
                systemFieldsNamesId[value.toLowerCase()] = key
            });

            debug && console.log(debug, '_getFieldsInFormula', matches)

            // collect fields for formula
            _.map(matches, (match)=>{

                let name = match[1].toLowerCase();

                const field3 = formulaField3Factory(match[0])
                if (field3) {
                    res.push({
                        name        : name,
                        field       : field3
                    });
                    return
                }


                name = patchToFixOldVariableNames(name)

                //first search for system field
                const systemFieldType = systemFieldsNamesId[name];

                // new
                const field = formulaField1Factory(name, systemFieldType, customFields)

                res.push({name, field});
            })
        }

        return res;
    },

    isFormulaValid(inputText:string) {
        const formulaVariables = Formula._getFieldsInFormula(inputText);
        let isValid : boolean   = true
        let error   : any       = undefined

        // formula is not valid if no field found or field value type is not number (gd.const.fields.valueType.FLOAT)
        _.map(formulaVariables, (fv)=>{

            // make sure Fields exist
            if (!fv.field) {
                isValid     = false;
                error       = 'invalid_field';
                return
            }

            // Make sure all fields are number/float based
            if (![gd.const.fields.valueType.FLOAT].includes(fv.field.getValueType())) {
                isValid = false;
                error = 'invalid_field';
            }
        })

        const regexp = new RegExp(/\{(.+?)\}/, 'gmis');
        let updatedText = _.replace(inputText, regexp, value=>'');

        const allowedCharacters = ['.','+','-','/','*','(',')',' '];
        for(let i = 0; i<10; i++) {allowedCharacters.push(''+i)}
        const notAllowedChars = _.filter(updatedText, char=>!allowedCharacters.includes(char));

        if (notAllowedChars.length > 0) {
            isValid = false;
            error = 'invalid_characters';
        }

        return {
            isValid,
            error
        };
    },

    process(inputText:string, item:any) {
        let res : any               = inputText;
        let updatedText : string    = ''

        const formulaVariables = Formula._getFieldsInFormula(inputText);

        debug && console.log(debug, 'process', inputText, item, formulaVariables)

        // vic 2024 jun1 && formulaVariables.length > 0
        // I removed this check ... so things like 1+1 could work :)

        if (!!inputText && typeof inputText === 'string' ) { //&& formulaVariables.length > 0
            try {
                //find all fields matches
                const regexp = new RegExp(/\{(.+?)\}/, 'gmis');

                // modify text for replacement
                let count   = 0;
                updatedText = _.replace(inputText, regexp, value=>'{{0}}'.f(count++))

                // collect fields value replacements
                const replacements : any = []
                _.map(formulaVariables, fv=>{
                    let value;

                    if (fv.field) value = fv.field.getFormulaValue(item);

                    //  if no value, then set to 0
                    if (_.isNil(value) || _.isNaN(value)) value = 0;

                    replacements.push({
                        name: fv.name,
                        value
                    });
                })

                debug && console.log(debug, 'process replacements', replacements)

                _.map(replacements, (r, key) => {
                    let value : any =  parseFloat(r.value)
                    /*if (typeof value === 'string') {
                        value = value.slice(0, 1) + (key !== 0 ? ' ' : '') + value.slice(1); // add space before string value if it is not the first one
                    }*/

                    updatedText = _.replace(updatedText, '{{0}}'.f(key), value);
                })

                // execute formula

                res = eval(updatedText);
                if (_.isNaN(res) || !isFinite(res)) res = null;
            } catch (e) {
                console.warn("Formula process error:", updatedText, e);
            }
        }

        debug && console.log(debug, 'process result', {
            result              : res,
            formulaWithValues   : updatedText
        })

        return {
            result              : res,
            formulaWithValues   : updatedText
        };
    }
};

export default Formula;
